import React from 'react';
import styles from './Ellipse.module.css';

const Ellipse = () => {
  return <div className={styles.ellipse} />;
};
export default Ellipse;
